export default __webpack_public_path__ + "static/media/AIG Dark.4535b440.svg";